module.exports = __webpack_public_path__ + "static/img/Dylan-Edwards.a4b71e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan-Edwards.jpg
// module id = lsTh
// module chunks = 0